import script from "./BidViewQuestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidViewQuestions.vue?vue&type=script&setup=true&lang=ts"

import "./BidViewQuestions.vue?vue&type=style&index=0&id=1fef7530&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fef7530"]])

export default __exports__